import enLocale from 'element-ui/lib/locale/lang/en'
export default {
  ...enLocale,
  notification:{
    title:'Notification',
    adminmanagemessage:'This admin will be delete forever，continue or not？',
    adminmanagemessage1:'Unable to query your own information, please view in My Info',
    adminmanagemessage2:'No related information is queried',
    adminlogmessage:'This log will be delete forever，continue or not？',
    permissionmanagemessage:'This role will be delete forever，continue or not？',
    permissionmanagemessage2:'The role information is incomplete!',
    carbrandmessage:'This brand and other data related to this brand will be delete forever，continue or not？',
    cardatadeletemessage:'This vehicle data will be delete forever，continue or not？',
    adminfilemessage:'This OTA file will be delete forever，continue or not？',
    appfilemessage:'This APP file will be delete forever，continue or not？',
    userfilemessage:'This OTA file will be delete forever，continue or not？',
    sensorbaseinfomessage:'The information and data of this sensor will be delete forever，continue or not？',
    sensordatamessage:'This data will be delete forever，continue or not？',
    applogmessage:'This log will be delete forever，continue or not？',
    syslogmessage:'This log will be delete forever，continue or not？',
    homemessage:'Logout？',
    confirm:'Confirm',
    cancel:'Cancel',
    cancelinfo:'Cancel Delete',
    cancelinfohome:'Cancel Logout',
    resetpwdmessage1:'Please enter old password!',
    resetpwdmessage2:'Please enter new password!',
    resetpwdmessage3:'The value of the character contains 3 to 20.',
    resetpwdmessage4:'Please enter new password again',
    usermanagemessage1:'Cancel modify password',
    cardatamessage:'Please select the type you want to query',
  },
  login: {
    login_title:'BH SENS TPMS Monitoring System',
    login_welcome: 'Welcome',
    username: 'Please enter username',
    password: 'Please enter password',
    login: 'Login',
  },
  home:{
    home_title:'BH SENS TPMS Monitoring System',
    MyInfo:'My Info',
    logout:'Logout',
    homepage:'Home',
    state1:'Good Morning!',
    state2:'Good Afternoon!',
    state3:'Good Afternoon!',
    state4:'Good Night!',
    home_welcome:'Welcome Back!',
    users:'Users',
    admins:'Admins',
    cars:'Cars',
    basicline:{
      title:'用户使用量',
      series:'总人数',
    },
  },
  file:{
    filename:'Files Manager',
    userfile:{
      title:'User File Manage',
      searchhint:'Search via phone number',
      searchbtn:'Search',
      phone:'Phone',
      filename:'File Name',
      version:'Version',
      createtime:'Create Time',
      operate:'Operate',
      download:'Download',
      delete:'Delete',
    },
    adminfile:{
      title:'Admin File Manage',
      sesrchhint:'Search via admin name',
      searchbtn:'Search',
      insertbtn:'Upload File',
      uploadtitle:'Upload OTA File',
      uploadbrandcn:'Brand(cn)',
      uploadbranden:'Brand(en)',
      uploadcarmodel:'Model',
      uploadcaryear:'Year',
      uploadcarconfig:'Config',
      uploadphone:'Phone',
      uploadversion:'Version',
      uploadupload:'Upload',
      uploadcancel:'Cancel',
      adminname:'Admin',
      otaname:'Ota Name',
      version:'Version',
      phone:'Phone',
      createtime:'Create Time',
      operate:'Operate',
      operatedownload:'Download',
      operatedelete:'Delete',
    },
    appfile:{
      title:'APP File Manage',
      searchhint:'Search via app name',
      searchbtn:'Search',
      insertbtn:'Upload',
      uploadtitle:'Upload APP File',
      uploadphone:'Phone',
      uploadapplicationID: 'APP ID',
      uploadversionname:'APP Name',
      uploadversioncode:'Version Code',
      old_versioncode:'Old Version Code',
      update_detail:'Update Detail',
      incremental_update:'Incremental update',
      uploadupload:'Upload',
      uploadcancel:'Cancel',
      appname:'APP Name',
      version:'Version',
      phone:'Phone',
      createtime:'Create Time',
      operate:'Operate',
      operatedownload:'Download',
      operatedelete:'Delete',
    
    },
  },
  adminmanage:{
    adminmanagename:'Admins Manager',
    searchadminhint:'Search via name',
    insertadmin:'Insert Admin',
    insertadmin_title:'Insert Admin',
    insertadmin_account:'Admin Account',
    insertadmin_pwd:'Password',
    insertbtn:'Insert',
    insertcancel:'Cancel',
    search:'Search',
    name:'Name:',
    createtime:'Create Time:',
    unable:'Unable',
    enable:'Enable',
    userrole:'Role:',
    rolelist:'Role List',
    select:'Select One',
  },
  admin:{
    adminmanage_title:'Admin Info',
    permissionmanage_title:'Role And Permission Manage',
  },
  permissionmanage:{
    role:'Role',
    newrole:'Insert Role',
    hint1:'Please enter role name in English name',
    hint2:'Please enter role name in Chinese name',
    span1:'Accessible resources',
    cancelmodify:'Modify cancel',
    confirmmodify:'Modify confirm',
  },
  usersmanage:{
    usersmanagename:'Users Manager',
    searchviaphone:'Search via phone number/EMail',
    btnsearch:'Search',
    btninsertuser:'Insert User',
    insertuser_title:'Insert User',
    username:'Name',
    phone:'Phone/EMail',
    avatar:'Avatar',
    registtime:'Regist Time',
    equipment:'Last Equipment',
    equipment1:'Web',
    equipment2:'Android',
    equipment3:'Mini Program',
    equipment4:'iOS',
    owncar:'Owned Cars (Clicked to view details)',
    operate1:'Operate',
    operate1_modifypassword:'Modify Password',
    operate1_modifyinfo:'Modify Info',
    operate1_delete:'Delete',
    operate1_deletewarn:'This operation will permanently delete the user,whether to continue?',
    operate1_deletewarnyes:'Yes',
    operate1_deletewarnno:'No',
    deletewarnnomessage:'Delete Cancel',
    carsinfo:'`s Cars` Information',
    carsinfo_modify_title:'Modify user`s car',
    carsinfo_id:'ID of user`s car',
    carsinfo_brand:'Brand',
    carsinfo_year:'Year',
    carsinfo_configuration:'Configuration',
    carsinfo_createtime:'Create Time',
    carsinfo_vin:'Vin',
    carsinfo_licenseplate:'License Plate',
    carsinfo_operate:'Operate',
    carsinfo_operate_modify:'Modify',
    carsinfo_operate_modify_cancel:'Cancel',
    carsinfo_operate_delete:'Delete',
    carsinfo_operate_deletewarn:'This operation will permanently delete the user`s vehicle info,whether to continue?',
    carsinfo_operate_deletewarnyes:'Yes',
    carsinfo_operate_deletewarnno:'Cancel',
    modifypwd_title:'Modify Password',
    modifypwd_phone:'Phone',
    modifypwd_newpwd:'New Password',
    modifypwd_newpwdagain:'New Password',
    modifypwd_cancel:'Cancel',
    modifypwd_modifypwd:'Modify Password',
    modifypwd_difpwd:'Two passwords are different,please re-enter!',
    modifyinfo_title:'Modify Info',
    modifyinfo_name:'Name',
    modifyinfo_phone:'Phone',
    modifyinfo_pwd:"Password",
    modifyinfo_enabled:'Enabled',
    modifyinfo_unabled:'Unabled',
    modifyinfo_modify:'Modify',
    modifyinfo_cancel:'Cancel',
  },
  carsmanage:{
    carsmanagename:'Cars Database',
    title1:'Car body styles data',
    title2:'Car brands data',
    cardata:{
      hint1:'Please select',
      select:{
        brandcn:'Search via brand(cn)',
        branden:'Search via brand(en)',
        model:'Search via model',
        year:'Search via year',
        configuration:'Search via configuration',
      },
      hint2:'Please enter content',
      insert:{
        title:'Insert car body style',
        btn:'Insert',
      },
      brandcn:'Brand(cn)',
      branden:'Brand(en)',
      model:'Model',
      year:'Year',
      configuration:'Configuration',
      createtime:'Create time',
      operate:'Operate',
      modify:{
        btn:'Modify',
        title:'Modify car data',
        id:'Car ID',
        cancel:'Cancel'
      },
      delete:'Delete',
      
    },
    carbrand:{
      hint1:'Please select',
      select:{
        brandcn:'Search via brand(cn)',
        branden:'Search via brand(en)',
      },
      hint2:'Please enter content',
      insert:{
        title:'Insert car brand',
        btn:'Insert',
        brandid:'Brand ID',
        brandcn:'Brand(cn)',
        branden:'Brand(en)',
      },
      operate:'Operate',
      modify:{
        btn:'Modify',
        title:'Modify car brand',
      },
      cancel:'Cancel',
      delete:'Delete',
    },
  },
  sensorsmanage:{
    sensorsmanagename:'Sensors Manager',
    title:'Sensor Info',
    sensorbaseinfo:{
      select:{
        hint:'Select',
        mac:'MAC',
        sensor:'Sensor',
        phone:'Phone/EMail',
      },
      hint:'Please enter',
      insert:{
        btn:'Insert sensor info',
        mac:'MAC',
        sensorid:'Sensor ID',
        phone:'Phone/EMail',
        bleconnectionSensor:'',
        companyID:'Company ID',
        ignstatus:'IGN',
        mileageOFTirePressureSensor:'Mileage of Sensor',
        presentDateAndTime:'Date',
        projectCode:'Project Code',
        softwareVersion:'Version',
        vehicleOdometer:'Vehicle odometer',
        // addData:'AD data',
        insert:'Insert',
        cancel:'Cancel',
      },

      mac:'MAC',
      sensorid:'Sensor ID',
      phone:'Phone/EMail',
      bleconnectionSensor:'',
      companyID:'Company ID',
      ignstatus:'IGN',
      mileageOFTirePressureSensor:'Mileage of Sensor',
      presentDateAndTime:'Date',
      projectCode:'Project Code',
      softwareVersion:'Version',
      vehicleOdometer:'Vehicle odometer',
      // addData:'AD data',
      operate:'Operate',
      modify:{
        btn:'Modify',
        title:'Modify sensor base info',
        mac:'MAC',
        sensroid:'Sensor ID',
        phone:'Phone',
        bleconnectionSensor:'',
        companyID:'Company ID',
        ignstatus:'IGN',
        mileageOFTirePressureSensor:'Mileage of Sensor',
        presentDateAndTime:'Date',
        projectCode:'Project Code',
        softwareVersion:'Version',
        vehicleOdometer:'Vehicle odometer',
        // addData:'AD data',
        cancel:'Cancel',
      },
      delete:'Delete',
    },
    sensordata:{
      historydata:{
        title:'History data',
        historydatatitle1:'MAC <',
        historydatatitle2:'>`s history data',
        select:{
          hint1:'Please select',
          hint2:'Please enter content',
          1:'Tire pressure',
          2:'Temperature',
          3:'Standard tire pressure',
          4:'Standard temperature',
        },
        insert:{
          btn:'Insert sensor data',
          title:'Insert sensor data',
          mac:'MAC',
          sensorid:'Sensor ID',
          tirep:'Tire pressure',
          temperature:'Temperature',
          stirep:'Standard tire pressure',
          stemperature:'Standard temperature',
          insert:'Insert',
          cancel:'Cancel',
        },
        inner_btn: '折线图',
        download_btn: 'Download datas',
        downloading: "Downloading...",
        packaging: "Packaging...",
        inner:{
          basiclineP:{
            series:'Pressure/kPa',
          },
          basiclineSP:{
            series:'Standard Pressure/kPa',
          },
          basiclineT:{
            series:'Temperature/℃',
          },
          basiclineST:{
            series:'Standard Temperature/℃',
          },
        },
        tirep:'Tire pressure/kPa',
        temperature:'Temperature/℃',
        stirep:'Standard tire pressure/kPa',
        stemperature:'Standard temperature/℃',
        date:'Date',
        operate:'Operate',
        modify:{
          btn:'Modify',
          title:'Modify Sensor data',
          mac:'MAC',
          sensorid:'Sensor ID',
          tirep:'Tire pressure',
          temperature:'Temperature',
          stirep:'Standard tire pressure',
          stemperature:'Standard temperature',
          modify:'Modify',
          cancel:'Cancel',
        },
        delete:'delete',
      },
    },
  },
  applogmanage:{
    applogmanagename:'APP Log Manager',
    searchhint:'Search via phone number',
    searchbtn:'Search',
    insertlog:'Insert Log',
    insert:{
      title:'Insert Log',
      phone:'Phone',
      logdetail:'Log detail',
      cancel:'Cancel',
      insert:'Insert',
    },
    logid:'Log ID',
    phone:'Phone',
    logdetail:'Log detail',
    logtype:'Log type',
    createtime:'Create time',
    operate:'Operate',
    modify:{
      btn:'Modify',
      title:'Modify Log',
      logid:'Log ID',
      createtime:'Create time',
      logtype:'Log type',
      phone:'Phone',
      logdetail:'Log detail',
      cancel:'Cancel',
      modify:'Modify',
    },
    delete:'Delete',
  },
  syslogmanage:{
    syslogmanagename:'System Log Manager',
    searchhint:'Search via some log contents',
    searchbtn:'Search',
    insertlog:'Insert Log',
    insert:{
      title:'Insert Log',
      logdetail:'Log detail',
      cancel:'Cancel',
      insert:'Insert',
    },
    logid:'Log ID',
    logdetail:'Log detail',
    logtype:'Log type',
    createtime:'Create time',
    operate:'Operate',
    modify:{
      btn:'Modify',
      title:'Modify Log',
      logid:'Log ID',
      createtime:'Create time',
      logtype:'Log type',
      logdetail:'Log detail',
      cancel:'Cancel',
      modify:'Modify',
    },
    delete:'Delete',
  },
  adminlogmanage:{
    adminlogmanagename:'Admin Log Manager',
    searchhint:'Search via admin name',
    searchbtn:'Search',
    insertbtn:'Insert Log',
    inserttitle:'Insert Log',
    insertlogdetSail:'Log Detail',
    insertcancel:'Cancel',
    insertinsert:'Insert',
    logid:'Log ID',
    adminname:'Admin Name',
    logtype:'Log Type',
    logdetail:'Log Detail',
    createtime:'Create Time',
    operate:'Operate',
    operatemodify:'Modify',
    operatedelete:'Delete',
    modifytitle:'Modify Log',
    modifylogid:'Log ID',
    modifycreatetime:'Create Time',
    modifylogtype:'Log Type',
    modifylogdetail:'Log Detail',
    modifycancel:'Cancel',
    modifymodify:'Modify',
  },
  filesmanage:{
    
  },
  userinfo:{
    title:'Base Info',
    tab1:'Base Info',
    tab2:'Change password',
    userinfo:{
      username:'User name',
      ownrole:'User Role',
    },
    useravatar:{
      title:'Profile picture',
      loadingtext:'Loading...',
      beforeupload:'Click picture to upload new picture',
      tip:'Only jpg/png files with a maximum size of 500kb can be uploaded',

    },
    resetpwd:{
      oldpwd:'Old password',
      oldpwdhint:'Please enter old password',
      newpwd:'New password',
      newpwdhint:'Please enter new password',
      confirmpwd:'Confirm new password',
      confirmpwdhint:'Please enter new password again',
      submit:'Change password',
      close:'Close',
      error1:'Passwords don`t match.',
    },
  },
}